import axios from 'axios'
import { getAPIService } from '../../../getServerHost'

export const getUserProfile = async (user_id: string) => {
  const response = await axios.get(`${getAPIService}/user_profile/${user_id}`)
  return response.data
}
